<template>
  <div class="container">
    <div class="title">{{formItem.title}}</div>
    <div v-if="formItem.exam_name" class="example" @click="goExample">
      {{formItem.exam_name}}
    </div>
  </div>
</template>
<script>
export default {
  props: ["formItem", "idx"],
  data() {
    return {};
  },
  methods: {
    goExample() {
      this.$router.push({
        name: "example",
        params: {
          pic_type: this.formItem.exam_pic_type,
          pics: this.formItem.exam_pic_url, //array
          pic_desc: this.formItem.pic_desc //object
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container{
  display: flex;
  align-items: center;
  min-height: 0.8rem;
  margin-top: 0.2rem;
}
.title{
  margin-right: 0.2rem;
  font-size: 0.36rem;
  font-weight: 900;
  color: #1F2933;
}
.example{
  font-size: 0.28rem;
  color: #999
}
</style>

